import axios from 'axios';

const getAllOtherServicesApi = async (paramsFilter, token, langIsoCode) => {
  try {
    const url = `/Service/getServices`;
    const res = await axios.get(url, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        lang: langIsoCode
      }
    });
    return res;
  } catch (error) {
    throw error;
  }
};

export default getAllOtherServicesApi;
